import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';

export function contextWithErrorHandlerForLoadItemRequestDetails(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // ENTITY_ID_NOT_FOUND: requested ItemRequest not found
          // GENERAL_INVALID_VALUE: requested ItemRequest does not match authenticated patron
          errorCodes: ['ENTITY_ID_NOT_FOUND', 'GENERAL_INVALID_VALUE'],
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForCreateItemRequest(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // requested branch not found
          errorCodes: 'BRANCH_INVALID_ID',
          actions: SnackBarActions.showError('Invalid branch selection.')
        },
        {
          // maximum number of requests per month reached
          errorCodes: 'MONTHLY_ITEM_REQUEST_LIMIT_EXCEEDED',
          actions: SnackBarActions.showError('Maximum number of requests reached.')
        },
        {
          // Also covers a dialog opened before an account block was added.
          errorCodes: 'ACTION_BLOCKED',
          actions: SnackBarActions.showError('Item requests are unavailable due to a block on your account.')
        },
        {
          // request body missing
          errorCodes: 'GENERAL_MISSING_PARAM',
          actions: SnackBarActions.showError('Missing or invalid request.')
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForSendItemRequestMessage(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // ENTITY_ID_NOT_FOUND: requested ItemRequest not found
          // GENERAL_INVALID_VALUE: requested ItemRequest does not match authenticated patron
          errorCodes: ['ENTITY_ID_NOT_FOUND', 'GENERAL_INVALID_VALUE'],
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForMarkItemRequestMessagesAsRead(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // requested ItemRequest does not match authenticated patron
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForCancelItemRequest(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // ENTITY_ID_NOT_FOUND: requested ItemRequest not found
          // GENERAL_INVALID_VALUE: requested ItemRequest does not match authenticated patron
          errorCodes: ['ENTITY_ID_NOT_FOUND', 'GENERAL_INVALID_VALUE'],
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        },
        {
          // requested ItemRequest is already settled
          errorCodes: 'REQUEST_INVALID_STATUS',
          actions: SnackBarActions.showError('This item request is already settled and cannot be canceled.')
        },
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
